const stag = {
  API_ENDPOINT_URL: "https://stusphere-stg-api.azurewebsites.net/api/",
  MOODLE_URL: "https://moodle.stusphere.org/webservice/rest/server.php",
  WSTOKEN: "1f5d23f35dd73682514fa39b6a934221",
};

const getEnv = () => {
  return stag;
};

export const env = getEnv();